<template>
  <div class="mobile-button-grid" v-if="isMobile">
    <div class="button-row">
      <div
        v-for="(button, index) in buttons.slice(0, 5)"
        :key="'top-' + index"
        class="button-item"
        @click="handleButtonClick(button)"
      >
        <img :src="button.icon" alt="" class="button-icon" />
        <span class="button-label">{{ button.label }}</span>
      </div>
    </div>

    <div class="button-row">
      <div
        v-for="(button, index) in buttons.slice(5, 10)"
        :key="'bottom-' + index"
        class="button-item"
        @click="handleButtonClick(button)"
      >
        <img :src="button.icon" alt="" class="button-icon" />
        <span class="button-label">{{ button.label }}</span>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions } from 'vuex';

export default {
  name: "MobileButtonGrid",
  data() {
    return {
      buttons: [
        { icon: require('@/assets/icons/mobile/vip.png'), label: "VIP", route: "/vip" },
        { icon: require('@/assets/icons/mobile/battlepass.png'), label: "BattlePass", route: "/battlepass" },
        { icon: require('@/assets/icons/mobile/tournament.png'), label: "Tournament", route: "/leaderboard" },
        { icon: require('@/assets/icons/mobile/bonus.png'), label: "Bonus", route: "/bonus" },
        { icon: require('@/assets/icons/mobile/reward.png'), label: "Rewards", route: "/rewards" },
        { icon: require('@/assets/icons/mobile/affiliate.png'), label: "Affiliate", route: "/affiliates" },
        { icon: require('@/assets/icons/mobile/vault.png'), label: "Vault", route: null }, // Modal
        { icon: require('@/assets/icons/mobile/profile.png'), label: "Profile", route: "/profile" },
        { icon: require('@/assets/icons/mobile/customer.png'), label: "Help", route: "/vip" },
        { icon: require('@/assets/icons/mobile/logout.png'), label: "Log Out", route: null }, // Special action
      ],
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
  },
  methods: {
    ...mapActions(['modalsSetShow', 'authLogoutUser']),
    
    handleButtonClick(button) {
      if (button.label === 'Vault') {
        this.modalsSetShow('Vault'); // Vuex'e kısa ad veriyoruz
      } else if (button.label === 'Log Out') {
        this.authLogoutUser(); // ÇIKIŞ
      } else if (button.route) {
        this.$router.push(button.route);
      }
    }
  }
};
</script>



<style scoped>
.mobile-button-grid {
  display: none;
  flex-direction: column;
  width: 100%;
  max-width: 95%; /* Sayfanın %95'ini kaplasın */
  margin: 0 auto 20px auto; /* Ortala ve alt boşluk bırak */
 
  z-index: 1;
  background: var(--category-bar);
  border-radius: 8px;
  position: relative;
  border-radius: 5px;
  margin-top: 20px;
}

 

.button-row {
  display: flex;
  justify-content: space-between;
}

.button-item {
  flex: 1;
  text-align: center;
  padding: 5px;
}

.button-icon {
  width: 40px;
  height: 40px;
  margin: 0 auto;
  position: relative;
  background: var(--background2);
  border-radius: 10px;
  padding: 5px;
  box-shadow: 0 2px 12px #00000029;
}

.button-icon::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, #fecf4a00 2%, #fecf4a 54.57%, #fecf4a00 99.99%);
  border-radius: 0 50px 0 0;
  pointer-events: none;
}



.button-label {
  display: block;
  margin-top: 5px;
  font-size: 10px;
  font-family: var(--font-header);
      font-weight: 600;
      color: white;
}
</style>
